module.exports = __webpack_public_path__ + "img/139.180982bd.jpg";